<p>base-edit-work-dates works!</p>
